import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";
import { BritishColumbiaObstetricalFileForm } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BritishColumbiaObstetricalFileForm";

class BritishColumbiaObstetricalFileMedicalHistoryImmunizations extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    private sectionId = "MedicalHistory_Section7_Immunizations";
    private medicalHistoryImmunizationsOther = `${this.sectionId}_Other`;
    private medicalHistoryImmunizationsFlu = `${this.sectionId}_Flu`;
    private medicalHistoryImmunizationsTdap = `${this.sectionId}_Tdap`;
    private dateRefs: { [index: string]: DateSelector } = {};

    public render(): JSX.Element {
        const section7 = this.props.form.Section7;

        return (
            <div className="col-md-12 flex-display section7-subfield padding-xs-top">
                <div className="flex-display">
                    {this.controlRenderer.renderInlineRadio({
                        value: section7.Immunizations.HasImmunizations,
                        items: this.getFalseTrueRadioOptionsWithoutLabel(),
                        onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Section7.Immunizations.HasImmunizations = value),
                        id: `${this.sectionId}_HasImmunizations`,
                        className: "radios-one-label",
                        optionSpacing: "15px"
                    })}
                    <label className="margin-none margin-xs-left">{this.getString("ImmunizationsLabel")}</label>
                </div>
                <div className="width-100">
                    {this.renderRadioCheckboxWithLabel(
                        `${this.sectionId}_Immunizations_Flu`,
                        "FluLabel",
                        section7.Immunizations.Flu.Value,
                        value => {
                            this.mutateImmunizationsModel(
                                s => s.Section7.Immunizations.Flu.Value = value,
                                true,
                                () => {
                                    if (value)
                                        this.dateRefs[this.medicalHistoryImmunizationsFlu]?.open();
                                }
                            );
                        },
                        this.controlRenderer.renderDateSelector({
                            id: this.medicalHistoryImmunizationsFlu,
                            value: section7.Immunizations.Flu.Date,
                            onChange: value => this.mutateImmunizationsModel(s => s.Section7.Immunizations.Flu.setDate(value)),
                            className: "width-100",
                            containerClassName: "margin-xs-left",
                            ref: ref => this.dateRefs[this.medicalHistoryImmunizationsFlu] = ref
                        }),
                        true,
                        "margin-md-left"
                    )}
                    {this.renderRadioCheckboxWithLabel(
                        `${this.sectionId}_Immunizations_Tdap`,
                        "QuebecVaccinationRegistry_Values_Agent_SCT_AG0016",
                        section7.Immunizations.TetanusDiphtheriaAcellularPertussisVaccine.Value,
                        value => {
                            this.mutateImmunizationsModel(
                                s => s.Section7.Immunizations.TetanusDiphtheriaAcellularPertussisVaccine.Value = value,
                                true,
                                () => {
                                    if (value)
                                        this.dateRefs[this.medicalHistoryImmunizationsTdap]?.open();
                                }
                            );
                        },
                        this.controlRenderer.renderDateSelector({
                            id: this.medicalHistoryImmunizationsTdap,
                            value: section7.Immunizations.TetanusDiphtheriaAcellularPertussisVaccine.Date,
                            onChange: value => this.mutateImmunizationsModel(s => s.Section7.Immunizations.TetanusDiphtheriaAcellularPertussisVaccine.setDate(value)),
                            className: "width-100",
                            containerClassName: "margin-xs-left",
                            ref: ref => this.dateRefs[this.medicalHistoryImmunizationsTdap] = ref
                        }),
                        true,
                        "margin-md-left"
                    )}
                    {this.renderRadioCheckboxWithLabel(
                        `${this.sectionId}_Immunizations_Other`,
                        "ObstetricalFile_OtherLabel",
                        section7.Immunizations.Other.Value,
                        value => {
                            this.mutateImmunizationsModel(
                                s => s.Section7.Immunizations.Other.Value = value,
                                true,
                                () => this.setFocusTextbox(value, this.medicalHistoryImmunizationsOther)
                            );
                        },
                        this.getAdditionalTextBox({
                            id: this.medicalHistoryImmunizationsOther,
                            value: section7.Immunizations.Other.Description,
                            onChange: value => this.mutateImmunizationsModel(s => s.Section7.Immunizations.Other.setDescriptionAndCheckbox(value)),
                            maxLength: this.page1FieldLimits.MedicalHistory_Immunizations_OtherDescription.MaxChars,
                            valueClassName: "margin-xs-left"
                        }),
                        true,
                        "margin-md-left"
                    )}
                </div>
            </div>
        );
    }

    private mutateImmunizationsModel(mutation: (state: BritishColumbiaObstetricalFileForm) => void, updateForm?: boolean, then?: () => void): void {
        this.props.mutateModelState(
            s => {
                mutation(s);
                if (s.Section7.Immunizations.HasImmunizations == null)
                    s.Section7.Immunizations.HasImmunizations = s.Section7.Immunizations.hasSelectedAnyMedicalHistoryImmunizations();
            },
            () => {
                if (updateForm)
                    this.props.handleFormUpdate();

                then?.();
            }
        );
    }
}

export { BritishColumbiaObstetricalFileMedicalHistoryImmunizations };
